const Close = ({ width = 14, height = 14 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.70068 3.7002L10.3003 10.2999M3.70068 10.2999L10.3003 3.7002"
      stroke="white"
      strokeLinecap="square"
    />
  </svg>
);

export default Close;
